import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { MenuComponent } from 'src/app/_metronic/kt/components';

import { LayoutUtilsService } from '../../core/_base/crud';
import { CrudService } from './crud.service';
import { cpfValidator } from '../validators/cpf.validator';
import { cnpjValidator } from '../validators/cnpj.validator';

@Directive()
export abstract class BaseFormComponent implements OnInit, OnDestroy {
  selectedTab = 0;
  loadingSubject = new BehaviorSubject<boolean | any>(false);
  loading$ = this.loadingSubject.asObservable();
  form: FormGroup | any;
  hasFormErrors = false;
  @ViewChild('elFocus') elFocus: ElementRef;
  propertyTitle: string;

  @Input() isDialog = false;

  @Input() componentListDialog: any;
  @Input() dialogRefList: any;
  @Output() componentListDialogNotify = new EventEmitter<boolean>();
  @Input() entityIdDialog = null;

  notityStatusResponseOk = new BehaviorSubject<any>(null);

  protected subscriptions: Subscription[] = [];

  entity: any;
  entityCopy: any;
  newEntityTitle: string;
  editEntityTitle: string;
  newEntitySuccess: string;
  editEntitySuccess: string;
  entityRoutePath: string;

  errorDesc = 'Verifique o formulário e tente novamente.';
  submitted = false;
  reloads = 0;

  activeTabId = 'tab1';

  componentTitle = '';
  companyKey = '';

  isPJ = false;
  inputFocused = false;

  maxDate = new Date();
  today: number = Date.now();
  ranges: any[] = [
    {
      value: [new Date(new Date().setDate(new Date().getDate())), new Date()],
      label: 'Hoje',
    },
    {
      value: [
        new Date(new Date().setDate(new Date().getDate() - 15)),
        new Date(),
      ],
      label: 'Últimos 15 dias',
    },
    {
      value: [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ],
      label: 'Últimos 30 dias',
    },
    {
      value: [
        new Date(new Date().setDate(new Date().getDate() - 60)),
        new Date(),
      ],
      label: 'Últimos 60 dias',
    },
  ];

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }

  constructor(
    protected activatedRoute: ActivatedRoute | null = null,
    protected service: CrudService<any> | null = null,
    protected cdr: ChangeDetectorRef | null = null,
    protected layoutUtilsService: LayoutUtilsService | null = null,
    protected router: Router | null = null
  ) {}

  canDeactivate() {
    return this.submitted || !this.form?.dirty;
  }

  ngOnInit() {
    this.cdr?.detectChanges();

    this.handleCompanyKey();

    this.loadingSubject.next(true);

    const loadById = (id: any) => {
      this.service?.loadByID(id).subscribe((res) => {
        this.entity = res;
        this.entityCopy = JSON.parse(JSON.stringify(res));
        this.initForm();
      });
    };

    if (this.entityIdDialog) {
      loadById(this.entityIdDialog);
      return;
    }

    this.activatedRoute?.params.subscribe((params) => {
      const id = params.id;
      if (id && id !== '') {
        loadById(id);
      } else {
        this.entity = {} as any;
        this.initForm();
      }
    });
  }

  handleCompanyKey(){
    const { hash } = window.location;
    this.companyKey = hash.replace('#/', '').split('/')[0];
  }

  ngOnDestroy() {
    this.subscriptions.forEach((el) => {
      if (el) {
        el.unsubscribe();
      }
    });
  }

  initForm() {
    this.componentTitle = this.getComponentTitle();
    this.submitted = false;
    this.handleSelectedTabQueryParam();
    this.createForm();
    this.loadingSubject.next(false);
    this.cdr && this.cdr.detectChanges();
    // tslint:disable-next-line: no-unused-expression
    this.elFocus && this.elFocus.nativeElement.focus();

    setTimeout(() => {
      MenuComponent.reinitialization();
    });
  }

  private handleSelectedTabQueryParam() {
    if (this.activatedRoute) {
      this.subscriptions.push(
        this.activatedRoute.queryParamMap
          .pipe(
            map((params) => {
              this.selectedTab = Number(params.get('st')) || 0;
            })
          )
          .subscribe()
      );
    }
  }

  abstract createForm(): void;

  getComponentTitle() {
    let result = `${this.newEntityTitle}`;
    if (!this.entity || !this.entity.id) {
      return result;
    }

    result = `${this.editEntityTitle}`;

    if (this.entity[this.propertyTitle]) {
      result += ' - ' + this.entity[this.propertyTitle];
    } else if (this.entity.name) {
      result += ' - ' + this.entity.name;
    } else if (this.entity.description) {
      result += ' - ' + this.entity.description;
    }

    return result;
  }

  onSubmit(withBack = false, saveAndNew = false) {
    if (!this.validateForm()) {
      return;
    }

    this.submitted = true;

    const entity = this.prepareEntity();
    entity.id = this.entity.id;

    // console.log(entity);
    // return;

    if (entity.id && entity.id !== '') {
      this.updateEntity(entity, withBack, saveAndNew);
      return;
    }

    this.addEntity(entity, withBack, saveAndNew);
  }

  validateForm(form: FormGroup | null = null) {
    this.hasFormErrors = false;

    const formToCheck = !form ? this.form : form;
    const controls = formToCheck.controls;

    /** check form */
    if (formToCheck.invalid) {
      Object.keys(controls).forEach((controlName) => {
        if (controls[controlName] instanceof FormGroup) {
          this.validateForm(controls[controlName] as any);
        }
        //console.log(controlName);
        //console.log(controls[controlName]?.errors);

        controls[controlName].markAsTouched();

        if (controls[controlName]?.errors) {
          // const inputEl = document.querySelector(
          //   'input[formcontrolname="' + controlName + '"]'
          // ) as any;
          const inputEl = document.querySelector(
            'select[formcontrolname="' +
              controlName +
              '"], input[formcontrolname="' +
              controlName +
              '"], textarea[formcontrolname="' +
              controlName +
              '"]'
          ) as any;

          !this.inputFocused && inputEl && this.handleFocusInput(inputEl);
        }
      });

      this.hasFormErrors = true;
      this.selectedTab = 0;
      return false;
    }
    return true;
  }

  private handleFocusInput(inputEl: any, attemps = 0) {
    if (attemps > 5) {
      return;
    }

    let inputFocused = false;
    inputEl.addEventListener('focus', (event: any) => {
      this.inputFocused = true;
      inputFocused = true;
    });

    inputEl.focus();

    setTimeout(() => {
      inputEl.removeEventListener('focus', (event: any) => {});

      let at = attemps;
      while (inputFocused === false && at <= 5) {
        at++;
        this.activeTabId = 'tab' + at;
        this.cdr?.detectChanges();
        this.handleFocusInput(inputEl, at);
      }
    });
  }

  prepareEntity() {
    const entity = this.form.getRawValue();

    this.handleBooleanValue(entity);

    return entity;
  }

  handleBooleanValue(entity: any) {
    Object.keys(entity).forEach((key) => {
      if (entity[key] === true || entity[key] === 'true') {
        entity[key] = true;
      }

      if (entity[key] === false || entity[key] === 'false') {
        entity[key] = false;
      }
    });
  }

  addEntity(entity: any, withBack = false, saveAndNew = false) {
    this.loadingSubject.next(true);

    this.service
      ?.save(entity)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
          this.selectedTab = 0;
          this.cdr?.detectChanges();
          window.scroll(0, 0);
        })
      )
      .subscribe(
        (res: any) => {
          this.entity = res;
          this.submitted = false;
          this.form.markAsPristine();

          if (this.executeAfterSave()) {
            return;
          }

          const message = this.newEntitySuccess;
          this.layoutUtilsService?.showToastNotification({
            title: message,
            icon: 'success',
          });

          if (saveAndNew) {
            this.goToNew(true);
            return;
          }

          if (withBack) {
            this.goBack(entity.id);
          } else {
            this.refreshEntity(true, res.id);
          }
        },
        (err) => this.submitError(err)
      );
  }

  updateEntity(entity: any, withBack = false, saveAndNew = false) {
    this.loadingSubject.next(true);

    this.service
      ?.save(entity)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
          this.selectedTab = 0;
          this.setActiveTabId('tab1');
          this.cdr?.detectChanges();
        })
      )
      .subscribe(
        (res: any) => {
          this.entity = res;
          this.submitted = false;
          this.form.markAsPristine();

          if (this.executeAfterSave()) {
            return;
          }

          window.scroll(0, 0);

          const message = this.editEntitySuccess;
          this.layoutUtilsService?.showToastNotification({
            title: message,
            icon: 'success',
          });

          if (saveAndNew) {
            this.goToNew(false);
            return;
          }

          if (withBack) {
            this.goBack(entity.id);
          } else {
            this.refreshEntity(false);
          }
        },
        (err) => this.submitError(err)
      );
  }

  executeAfterSave() {
    return false;
  }

  submitError(err: any, toast = true, defaultMsg = '') {
    let message =
      defaultMsg || 'Ops! Não foi possível prosseguir com essa ação';

    if (err.error && err.error.violations && err.error.violations.length > 0) {
      message = err.error.violations[0].message;
    }

    if (err.error && err.error['hydra:description']) {
      message = err.error['hydra:description']; // replace \n por <br>
    }

    if (err.error && err.error.message) {
      message = err.error.message; // replace \n por <br>
    }

    if (err.status === 500) {
      message = 'Não foi possível realizar essa operação';
    }

    //message = message.indexOf(': ') !== -1 ? message.split(': ')[1] : message;

    if (toast) {
      this.layoutUtilsService?.showToastNotification({
        title: message,
        icon: 'error',
      });
    }

    if (!toast) {
      this.layoutUtilsService?.showActionNotification({
        html: message,
        icon: 'error',
      });
    }
  }

  refreshEntity(isNew = false, id = 0) {
    if (this.isDialog) {
      this.openComponentListDialog();
      return;
    }

    const url = this.router?.url;
    if (!isNew) {
      // this.router.navigate([url], { relativeTo: this.activatedRoute });
      setTimeout(() => this.ngOnInit());
      return;
    }

    this.router?.navigateByUrl(
      `/${this.companyKey}/${this.entityRoutePath}/edit/${id}`,
      {
        relativeTo: this.activatedRoute,
      } as any
    );
  }

  openComponentListDialog() {
    this.componentListDialogNotify.next(true);
    this.dialogRefList.removePanelClass('kt-hide');
    this.dialogRefList.componentInstance.refreshChild();
  }

  goBack(id: any) {
    if (this.isDialog) {
      this.openComponentListDialog();
      return;
    }

    this.loadingSubject.next(false);
    const url = `/${this.companyKey}/${this.entityRoutePath}?id=${id}`;
    this.router?.navigateByUrl(url, { relativeTo: this.activatedRoute } as any);
  }

  goToNew(isNew = false) {
    if (isNew) {
      this.ngOnInit();
      return;
    }
    this.router?.navigateByUrl(
      `/${this.companyKey}/${this.entityRoutePath}/new`,
      {
        relativeTo: this.activatedRoute,
      } as any
    );
  }

  onAlertClose($event: any) {
    this.hasFormErrors = false;
  }

  setActiveTabId(tabId: string) {
    this.activeTabId = tabId;
  }

  getCpfCnpjMask(fieldName: string): string {
    const control: FormControl = this.form.controls[fieldName];

    if (!control.value) {
      return '';
    }

    const value = control.value.replace(/\D/g, '');

    const _isCpf = value == null ? true : value.length < 12 ? true : false;

    this.isPJ = _isCpf ? false : true;

    return _isCpf ? '000.000.000-009' : '00.000.000/0000-00';
  }

  getCpfCnpjMaskText(value: string): string {
    const _isCpf = value == null ? true : value.length < 12 ? true : false;

    return _isCpf ? '000.000.000-009' : '00.000.000/0000-00';
  }

  getPhoneMask(fieldName: string): string {
    const control: FormControl = this.form.controls[fieldName];

    const _isFixed =
      control.value == null ? true : control.value.length < 11 ? true : false;

    return _isFixed ? '(00) 0000-00009' : '(00) 00000-0000';
  }

  getPhoneMaskValue(value: string): string {
    const _isFixed = value == null ? true : value.length < 11 ? true : false;

    return _isFixed ? '(00) 0000-00009' : '(00) 00000-0000';
  }

  selectTrackByFn(item: any) {
    return item.id;
  }

  handleDocumentType(fieldName: string, isRequired = true) {
    const value = this.form.controls[fieldName].value;
    const hasValue = value?.length > 0;
    const _isCpf = value == null ? true : value.length < 12 ? true : false;

    if (_isCpf) {
      const validators: any[] = hasValue ? [cpfValidator] : [];
      if (isRequired) {
        validators.push(Validators.required);
      }

      this.form.controls[fieldName].setValidators(validators);
    }

    if (!_isCpf) {
      const validators: any[] = hasValue ? [cnpjValidator] : [];
      if (isRequired) {
        validators.push(Validators.required);
      }

      this.form.controls[fieldName].setValidators(validators);
    }

    setTimeout(() => {
      this.form.controls[fieldName].updateValueAndValidity({
        onlySelf: true,
        emitEvent: false,
      });
    }, 200);
  }
}
